import { render, staticRenderFns } from "./CommunityUserDetails.vue?vue&type=template&id=7ac50733"
import script from "./CommunityUserDetails.vue?vue&type=script&lang=js"
export * from "./CommunityUserDetails.vue?vue&type=script&lang=js"
import style0 from "./CommunityUserDetails.vue?vue&type=style&index=0&id=7ac50733&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports